<template>
  <div class="page" v-if="hint.length === 0">
    <div class="section main" v-if="employee.length === 0" style="display: flex; align-items: center; justify-content: center; color: white">
        <div class="spinner">
          <div class="dot1"></div>
          <div class="dot2"></div>
        </div>
        <svg>
            <defs>
                <filter id='goo'>
                    <feGaussianBlur in='SourceGraphic' stdDeviation='8' result='blur' />
                    <feColorMatrix in='blur' values='
                        1 0 0 0 0
                        0 1 0 0 0
                        0 0 1 0 0
                        0 0 0 50 -8' result='goo' />
                    <feBlend in='SourceGraphic' in2='goo' />
                </filter>
            </defs>
        </svg>
        Загрузка профиля
    </div>
    <div class="section main" v-if="employee.length > 0">
      <div>
        <div style="display: flex; justify-items: center; align-items: center; justify-content: space-between; padding: 16px;">
          <div>
            <div class="value light" @click="$router.push('/stats')">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="currentColor"
                      d="M12,7.09L14.45,8.58L13.8,5.77L16,3.89L13.11,3.64L12,1L10.87,3.64L8,3.89L10.18,5.77L9.5,8.58L12,7.09M15,23H9V10H15V23M1,17V23H7V17H1M5,21H3V19H5V21M17,13V23H23V13H17M21,21H19V15H21V21Z"/>
              </svg>
            </div>
          </div>
          <img style="width: 10em;"
               src="https://www.enchy.ru/upload/iblock/ef2/ef25a2ef179a75a4328d3a64c40328e7.png" alt="Логотип" />
          <div>
            <div class="value light" @click="$router.push('/employee')">
              <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                <path fill="currentColor" d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4M9.75,7.82C8.21,7.82 7,9.03 7,10.57C7,12.46 8.7,14 11.28,16.34L12,17L12.72,16.34C15.3,14 17,12.46 17,10.57C17,9.03 15.79,7.82 14.25,7.82C13.38,7.82 12.55,8.23 12,8.87C11.45,8.23 10.62,7.82 9.75,7.82Z" />
              </svg>
            </div>
          </div>
        </div>
        <div class="label" style="text-align: center">Приветствуем!</div>

        <div class="balance" style="justify-content: center">
          <div style="position: relative" @click="$router.push('/historyOwn')">
            <svg style="z-index: 10; position: absolute; top: 0; left: 0; right: 0; bottom: 6px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="#fff" d="M12,21.35L10.55,20.03C5.4,15.36 2,12.27 2,8.5C2,5.41 4.42,3 7.5,3C9.24,3 10.91,3.81 12,5.08C13.09,3.81 14.76,3 16.5,3C19.58,3 22,5.41 22,8.5C22,12.27 18.6,15.36 13.45,20.03L12,21.35Z" /></svg>
            <div class="value" style="z-index: 11; text-shadow: none; color: dodgerblue"> {{ amount }}
                        </div>
            <div style="color: #fff; font-size: 14px; padding-top: 9px"> Мои СПАСИБО</div>
          </div>
        </div>
      </div>

      <div style="margin-bottom: 66px">
        <div class="balance" style="display: flex; align-items: center; justify-content: center; font-size: 16px">
          <button @click="$router.push('/employee')" style="text-shadow: none; border: none; font-size: 16px; background: #ffffffee; color: dodgerblue; padding: 12px 16px; border-radius: 12px; font-weight: bold">Сказать СПАСИБО</button>
        </div>
        <div style="display: flex; align-items: center; justify-content: center; font-size: 16px">
          <button @click="showHint()" style="display: flex; align-items: center;border: none; margin: 0 16px; background: #00000024; color: #fff; padding: 6px 12px; border-radius: 12px; font-weight: lighter">
            Вы можете сказать еще {{ count }} СПАСИБО             <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style=" margin-left: 16px;width: 24px; height: 24px"><path fill="#fff" d="M12 2C11.5 2 11 2.19 10.59 2.59L2.59 10.59C1.8 11.37 1.8 12.63 2.59 13.41L10.59 21.41C11.37 22.2 12.63 22.2 13.41 21.41L21.41 13.41C22.2 12.63 22.2 11.37 21.41 10.59L13.41 2.59C13 2.19 12.5 2 12 2M12 6.95C14.7 7.06 15.87 9.78 14.28 11.81C13.86 12.31 13.19 12.64 12.85 13.07C12.5 13.5 12.5 14 12.5 14.5H11C11 13.65 11 12.94 11.35 12.44C11.68 11.94 12.35 11.64 12.77 11.31C14 10.18 13.68 8.59 12 8.46C11.18 8.46 10.5 9.13 10.5 9.97H9C9 8.3 10.35 6.95 12 6.95M11 15.5H12.5V17H11V15.5Z" /></svg>

          </button>
        </div>
      </div>

      <div>
        <div class="balance">
          <div>
            <span class="value light" @click="$router.push('/thanks')">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="currentColor"
                      d="M15.58,16.8L12,14.5L8.42,16.8L9.5,12.68L6.21,10L10.46,9.74L12,5.8L13.54,9.74L17.79,10L14.5,12.68M20,12C20,10.89 20.9,10 22,10V6C22,4.89 21.1,4 20,4H4A2,2 0 0,0 2,6V10C3.11,10 4,10.9 4,12A2,2 0 0,1 2,14V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V14A2,2 0 0,1 20,12Z"/>
              </svg>
            </span>
            <div style="font-weight: lighter"> Ценности </div>
          </div>
          <div @click="$router.push('/history')">
            <div class="value light">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
              <path fill="currentColor" d="M21 11.11V5C21 3.9 20.11 3 19 3H14.82C14.4 1.84 13.3 1 12 1S9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.11 3.9 21 5 21H11.11C12.37 22.24 14.09 23 16 23C19.87 23 23 19.87 23 16C23 14.09 22.24 12.37 21 11.11M12 3C12.55 3 13 3.45 13 4S12.55 5 12 5 11 4.55 11 4 11.45 3 12 3M5 19V5H7V7H17V5H19V9.68C18.09 9.25 17.08 9 16 9H7V11H11.1C10.5 11.57 10.04 12.25 9.68 13H7V15H9.08C9.03 15.33 9 15.66 9 16C9 17.08 9.25 18.09 9.68 19H5M16 21C13.24 21 11 18.76 11 16S13.24 11 16 11 21 13.24 21 16 18.76 21 16 21M16.5 16.25L19.36 17.94L18.61 19.16L15 17V12H16.5V16.25Z" />
                  </svg></div>
            <div style="font-weight: lighter"> История</div>
          </div>
          <div>
            <span class="value light" @click="$router.push('/products')">
              <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                <path fill="currentColor"
                      d="M5.06 3C4.63 3 4.22 3.14 3.84 3.42S3.24 4.06 3.14 4.5L2.11 8.91C1.86 10 2.06 10.95 2.72 11.77L3 12.05V19C3 19.5 3.2 20 3.61 20.39S4.5 21 5 21H19C19.5 21 20 20.8 20.39 20.39S21 19.5 21 19V12.05L21.28 11.77C21.94 10.95 22.14 10 21.89 8.91L20.86 4.5C20.73 4.06 20.5 3.7 20.13 3.42C19.77 3.14 19.38 3 18.94 3H5.06M18.89 4.97L19.97 9.38C20.06 9.81 19.97 10.2 19.69 10.55C19.44 10.86 19.13 11 18.75 11C18.44 11 18.17 10.9 17.95 10.66C17.73 10.43 17.61 10.16 17.58 9.84L16.97 5L18.89 4.97M5.06 5H7.03L6.42 9.84C6.3 10.63 5.91 11 5.25 11C4.84 11 4.53 10.86 4.31 10.55C4.03 10.2 3.94 9.81 4.03 9.38L5.06 5M9.05 5H11V9.7C11 10.05 10.89 10.35 10.64 10.62C10.39 10.88 10.08 11 9.7 11C9.36 11 9.07 10.88 8.84 10.59S8.5 10 8.5 9.66V9.5L9.05 5M13 5H14.95L15.5 9.5C15.58 9.92 15.5 10.27 15.21 10.57C14.95 10.87 14.61 11 14.2 11C13.89 11 13.61 10.88 13.36 10.62C13.11 10.35 13 10.05 13 9.7V5M7.45 12.05C8.08 12.67 8.86 13 9.8 13C10.64 13 11.38 12.67 12 12.05C12.69 12.67 13.45 13 14.3 13C15.17 13 15.92 12.67 16.55 12.05C17.11 12.67 17.86 13 18.8 13H19.03V19H5V13H5.25C6.16 13 6.89 12.67 7.45 12.05Z"/>
              </svg>
            </span>
            <div style="font-weight: lighter"> Магазин</div>
          </div>
        </div>
          <div class="feedback">
            <svg style="width:18px;height:18px" viewBox="0 0 24 24" @click="$router.push('/feedback')">
                <path fill="currentColor" d="M9 22C8.4 22 8 21.6 8 21V18H4C2.9 18 2 17.1 2 16V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V16C22 17.1 21.1 18 20 18H13.9L10.2 21.7C10 21.9 9.8 22 9.5 22H9M10 16V19.1L13.1 16H20V4H4V16H10M16.3 6L14.9 9H17V13H13V8.8L14.3 6H16.3M10.3 6L8.9 9H11V13H7V8.8L8.3 6H10.3Z" />
            </svg>
            <div @click="$router.push('/feedback')">
                Обратная связь
            </div>
            <svg style="width:18px;height:18px;margin: 0 8px 0 auto" viewBox="0 0 24 24">
                <path fill="currentColor" d="M19,3H5C3.89,3 3,3.89 3,5V9H5V5H19V19H5V15H3V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3M10.08,15.58L11.5,17L16.5,12L11.5,7L10.08,8.41L12.67,11H3V13H12.67L10.08,15.58Z" />
            </svg>
            <div @click="signOut">
                Выход
            </div>
          </div>
      </div>

    </div>
  </div>
  <div class="page" v-else>
    <p style="font-size: 16px; color: #fff; margin: 16px 32px; text-align: center"> {{ hint }} </p>

    <div class="balance" style="display: flex; align-items: center; justify-content: center; font-size: 16px">
      <button @click="hint = ''" style="border: none; font-size: 16px; background: #ffffff55; color: #fff; padding: 12px 16px; border-radius: 12px; font-weight: bold">Закрыть</button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ProfilePage',
  metaInfo() {
    return {
      title: 'СПАСИБО',
      meta: [
        {name: 'viewport', content: 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0'}
      ]
    }
  },
  data: function() {
    return {
      token: '',
      hint: '',
      shown: false
    }
  },
    beforeMount() {
      window.addEventListener('beforeinstallprompt', (e) => {
        e.preventDefault()
        this.shown = true
      })
    },
  mounted() {
    this.init()
  },
  computed: {
    employee() {
      return this.$store.getters.employee
    },
    profile() {
      return this.$store.getters.profile
    },
    to() {
      return this.$store.getters.to
    },
    orders() {
      return this.$store.getters.orders
    },
    amount() {
      return this.$store.getters.amount
    },
    count() {
      return 3 - this.thanks.filter(it => it.worth !== 999 && new Date(it.date).getMonth() === new Date().getMonth() && new Date(it.date).getFullYear() === new Date().getFullYear()).length
    },
    thanks() {
      return this.$store.getters.from
    },
  },
  methods: {
    showHint() {
      this.hint = 'Каждый месяц Вам начисляются 3 СПАСИБО, которые Вы можете отправить коллеге с комментариями благодарности.';
    },
    signOut() {
        this.$store.dispatch('signOut')
        this.$router.push('/login')
    },
    init() {
      this.$store.dispatch('loadProfile')
    }
  }
}
</script>

<style scoped>

* {
    text-shadow: 0 2px 8px rgba(1, 12, 24, 0.35);
}

.main {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: rgb(17,26,103);
  background: radial-gradient(circle, rgba(17,26,103,0) 33%, rgba(1,0,4,.5) 100%);
}

.label {
  color: #ddd;
  font-family: sans-serif;
  font-weight: 300;
  font-size: 13px;
  white-space: pre-wrap;
  letter-spacing: .5px;
  margin-bottom: 16px;
}

.balance {
  width: calc(100% - 32px);
  color: #eeeeee;
  font-family: sans-serif;
  font-weight: 600;
  text-align: center;
  font-size: 14px;
  padding: 16px;
  display: flex;
  justify-content: space-between;
}

.balance div {
  width: 80px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.balance svg {
  margin-top: 16px;
}

.balance .light {
  color: #fff !important;
  background: rgba(120, 126, 128, 0.21) !important;
}

.balance .value {
  color: #2980b9 !important;
  font-family: sans-serif;
  font-weight: lighter;
  text-align: center;
  font-size: 26px;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  line-height: 56px;
  margin-bottom: 8px;
  margin-top: 24px;
}

@keyframes bounce-out-down {
  0% {
    transform: translateY(0);
  }
  20% {
    opacity: 1;
    transform: translateY(-20px);
  }
  100% {
    opacity: 0;
    transform: translateY(20px);
  }
}

svg {
  color: white;
}

.spinner {
  margin: 100px auto;
  width: 40px;
  height: 40px;
  position: relative;
  text-align: center;

  -webkit-animation: sk-rotate 2.0s infinite linear;
  animation: sk-rotate 2.0s infinite linear;
}

.dot1, .dot2 {
  width: 60%;
  height: 60%;
  display: inline-block;
  position: absolute;
  top: 0;
  background-color: #fff;
  border-radius: 100%;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.dot2 {
  top: auto;
  bottom: 0;
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-rotate { 100% { transform: rotate(360deg) }}
@keyframes sk-rotate { 100% { transform: rotate(360deg); }}

@-webkit-keyframes sk-bounce {
  0%, 100% {transform: scale(0.0) }
  50% { transform: scale(1.0) }
}

@keyframes sk-bounce {
  0%, 100% {
    transform: scale(0.0);
  } 50% {
    transform: scale(1.0);
  }
}

.feedback {
    display: flex;
    align-items: center;
    color: #aaa;
    font-size: 12px;
    padding: 10px 18px 10px;
    background: rgba(120, 126, 128, 0.21);
}

.feedback svg {
    color: #aaa;
    margin-right: 12px;
}
</style>
